import { LenderProfile } from '@trnsact/trnsact-shared-types';
import { SelectOption } from 'global';
import { SendApplicationPortalConfigFormValues, SendApplicationPortalConfig } from '../types';
import { PortalConfiguration } from 'modules/portalConfigurations/types';
import { keyBy } from 'utils/arrayUtils';

export const getLenderProfilesWithOcaOptions = (lenderProfiles: LenderProfile[]): SelectOption<string>[] =>
  lenderProfiles.map(({ lenderProfileId, name }) => ({ label: name!, value: lenderProfileId })) ?? [];

export const getConfigToSave = (
  portalConfiguration: PortalConfiguration<SendApplicationPortalConfig>,
  formData: SendApplicationPortalConfigFormValues
): PortalConfiguration<SendApplicationPortalConfig> => {
  const lenderProfileIds = formData.excludedLenderProfiles.map(lp => lp.value);

  const config: SendApplicationPortalConfig = {
    ...portalConfiguration.jsonDefinition.config,
    excludedLenderProfileIds: lenderProfileIds,
  };

  return {
    ...portalConfiguration,
    jsonDefinition: { config },
  };
};

export const getFormDefaultValues = (
  portalConfigurationConfig: SendApplicationPortalConfig,
  lenderProfilesWithOcaOptions: SelectOption<string>[]
): SendApplicationPortalConfigFormValues => {
  const lenderProfilesWithOcaOptionsById = keyBy(lenderProfilesWithOcaOptions, 'value');
  return {
    excludedLenderProfiles: portalConfigurationConfig.excludedLenderProfileIds.map(id => ({
      value: id,
      label: lenderProfilesWithOcaOptionsById[id]?.label ?? '',
    })),
  };
};
